import { fileRequiredValidate } from "validators";
import * as yup from "yup";

const createFleetModelValidator = yup
  .object({
    price_per_minute: yup
      .string()
      .required("Price Per Minute is required")
      .test("is-digit", "Input should be number", (value) =>
        /\d+$/.test(value)
      ),
    seat_number: yup
      .string()
      .required("Seat number is required")
      .test("is-digit", "Input should be number", (value) =>
        /\d+$/.test(value)
      ),
    base_fare: yup
      .string()
      .required("Base Fare is required")
      .test("is-digit", "Input should be number", (value) =>
        /\d+$/.test(value)
      ),
    special_price_per_kilo_meter: yup
      .string()
      .required("Special Price Per Kilo Meter is required")
      .test("is-digit", "Input should be number", (value) =>
        /\d+$/.test(value)
      ),
    price_per_kilo_meter: yup
      .string()
      .required("Price Per Kilo Meter is required")
      .test("is-digit", "Input should be number", (value) =>
        /\d+$/.test(value)
      ),
    name: yup.string().required("Name is required"),
    special_base_fare: yup
      .string()
      .required("Special Base Fare is required")
      .test("is-digit", "Input should be number", (value) =>
        /\d+$/.test(value)
      ),
    special_price_per_minute: yup
      .string()
      .required("Special Price Per Minute is required")
      .test("is-digit", "Input should be number", (value) =>
        /\d+$/.test(value)
      ),
    exceptional_km: yup
      .string()
      .required("Exceptional Price Per Minute is required")
      .test("is-digit", "Input should be number", (value) =>
        /\d+$/.test(value)
      ),
    exceptional_base_fare: yup
      .string()
      .required("Exceptional Price Per Minute is required")
      .test("is-digit", "Input should be number", (value) =>
        /\d+$/.test(value)
      ),
    exceptional_price_per_kilo_meter: yup
      .string()
      .required("Exceptional Price Per Minute is required")
      .test("is-digit", "Input should be number", (value) =>
        /\d+$/.test(value)
      ),
    exceptional_price_per_minute: yup
      .string()
      .required("Exceptional Price Per Minute is required")
      .test("is-digit", "Input should be number", (value) =>
        /\d+$/.test(value)
      ),
    manual_base_fare: yup
      .string()
      .nullable()
      .default("0")
      .test("is-number-or-empty", "Input should be a number or empty", (value) => !value ? true : /^\d+(\.\d+)?$/.test(value)),
    app_booking_percent: yup
      .string()
      .nullable()
      .default("0")
      .test("is-number-or-empty", "Input should be a number or empty", (value) => !value ? true : /^\d+(\.\d+)?$/.test(value)),
    admin_dispatch_percent: yup
      .string()
      .nullable()
      .default("0")
      .test("is-number-or-empty", "Input should be a number or empty", (value) => !value ? true : /^\d+(\.\d+)?$/.test(value)),
    passenger_reward_percent: yup
      .string()
      .nullable()
      .default("0")
      .test("is-number-or-empty", "Input should be a number or empty", (value) => !value ? true : /^\d+(\.\d+)?$/.test(value)),
    is_shared: yup.boolean(),
    search_radius: yup
      .string()
      .nullable()
      .test("is-number-or-empty", "Input should be a number or empty", (value) => {
        if (!value || value.trim() === "") return true;
        return /^\d+(\.\d+)?$/.test(value);
      })
      .test("min-value", "Search radius must be >= 0", (value) => {
        if (!value || value.trim() === "") return true;
        const num = parseFloat(value);
        return !isNaN(num) && num >= 0;
      }),
    image: yup
      .mixed()
      .required("Image is required")
      .test("image-required", "Image is required", fileRequiredValidate),
  })
  .required();

export default createFleetModelValidator;
